import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchProductListByIds,
} from '../../../redux/slices/notificationSlice'
import CustomModal from 'components/CustomModal'
import ProductViewer from './ProductPreviewViewer'
import FormLabel from 'components/form/FormLabel'
import CustomTable from 'components/table/CustomTable'
import { TableRow } from 'components/table/CustomTable'
import { TableHeader } from 'components/table/CustomTable'
import { TableCell } from 'components/table/CustomTable'
import { CommonTabGroup } from 'components/tab/TabGroup'
import { CommonTab } from 'components/tab/CustomTab'
import { productType } from '../constants'


const ProductPreview = ({ showModal, setShowModal }) => {
  const dispatch = useDispatch()

  const {
    product: { loading, data },
  } = useSelector((state) => state.notification)

  const [products, setProducts] = useState()
  const [activeTab, setActiveTab] = useState(productType[0])

  const isMobileView = showModal?.type === 'mobile'

  useEffect(() => {
    if (!isMobileView) {
      let ids = showModal?.data?.map((item) =>
        item.products?.map((product) => product.id),
      )
      if (ids.length) {
        ids = ids.reduce((acc, val) => acc.concat(val))
      }
      dispatch(fetchProductListByIds([...new Set(ids)]))
      setActiveTab(showModal?.data[0].type === 'cart' ? productType[0] : productType[1])
    }
  }, [])

  useEffect(() => {
    let v = {}
    showModal.data.forEach((element) => {
      v[element.type] = data.filter((d) =>
        element.products.map((p) => p.id).includes(d.product_id),
      )
    })
    setProducts({
      ...v,
    })
  }, [data])

  return (
    <CustomModal
      title={'Products'}
      showModal={showModal.data.length}
      setShowModal={() => setShowModal()}
      loading={false}
      bodyClasses="max-w-xl"
      secondaryButtonLabel="Close"
      childrenClass= {(products?.cart && !products?.wishlist) || (!products?.cart && products?.wishlist) ? "" : "pt-0 sm:pt-0"}
    >
      {isMobileView ? (
        <CustomTable>
          <thead>
            <TableRow>
              <TableHeader>S/N</TableHeader>
              <TableHeader>User Number</TableHeader>
              <TableHeader/>
            </TableRow>
          </thead>
          <tbody>
            {showModal.map((v, index) => {
              return <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{v}</TableCell>
              </TableRow>
            })}
          </tbody>
        </CustomTable>
      ) : (
        <>
          {(products?.cart && products?.wishlist) &&
          <CommonTabGroup extClass="sticky top-0 left-0 right-0 bg-white">
            {productType.map((p) =>
              <CommonTab children={p} active={activeTab === p} onClick={() => {
                setActiveTab(p);
              }}/>
            )}
          </CommonTabGroup>
          }
          <div className="flex flex-col space-y-3">
            <div>
              {(products?.cart && activeTab === 'Cart') && (
                <>
                  {(products?.cart && !products?.wishlist) &&
                    <FormLabel label="Cart" />
                  }
                  <ProductViewer
                    loading={loading}
                    data={products.cart}
                    hasRemove={false}
                    className="py-0"
                  />
                </>
              )}
              {(products?.wishlist && activeTab === 'Wishlist') && (
                <>
                  {(!products?.cart && products?.wishlist) &&
                    <FormLabel label="Wishlist" />
                  }
                  <ProductViewer
                    loading={loading}
                    data={products.wishlist}
                    hasRemove={false}
                    className="py-0"
                  />
                </>
              )}
            </div>
          </div>
        </>
      )}
    </CustomModal>
  )
}

export default ProductPreview;
